import { useState } from "react";
import { Card } from "antd";
import { AvitoButtonModal } from "src/enitities/Integration";

const { Meta } = Card;

export default function IntegrationAvito({ query, websocket }) {
  const [actions] = useState([<AvitoButtonModal key="connect" query={query} websocket={websocket} />]);

  return (
    <Card
      style={{ width: 250 }}
      cover={
        <div
          style={{
            display: "flex",
            height: 250,
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "#00a046",
            color: "white",
          }}
        >
          <h3>Avito</h3>
        </div>
      }
      actions={actions}
    >
      <Meta title="Avito" description={""} />
    </Card>
  );
}

